// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OpenInNew: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 38" enableBackground="new 0 0 38 38" xmlSpace="preserve">
<g>
	<path d="M33.58,33.58H4.42V4.42H19V0.25H4.42c-2.31,0-4.17,1.88-4.17,4.17v29.17c0,2.29,1.85,4.17,4.17,4.17h29.17
		c2.29,0,4.17-1.88,4.17-4.17V19h-4.17V33.58z"/>
	<polygon points="23.17,0.25 23.17,4.42 30.65,4.42 10.17,24.9 13.1,27.83 33.58,7.35 33.58,14.83 37.75,14.83 37.75,0.25 	"/>
</g>
</svg>;
};

export default React.memo(OpenInNew);
